module.exports = __webpack_public_path__ + "img/sample_header_2.1b5adbe5.jpg";